const USER_ROLES = {
  OPS: 'operations',
  RENTER: 'renter',
  RESERVATION_ADMIN: 'reservation admin',
  SUPER_ADMIN: 'super admin',
  VENUE_ADMIN: 'venue admin',
  GROUP_LEADER: 'group leader'
};

export default USER_ROLES;

export const ADMIN = 1;
export const GROUP_LEADER = 6;
export const RESERVATION_ADMIN = 4;
